import { useDeploymentsStore } from '@/common/store/pinia/deployments';

const fetchDeploymentName = async (deploymentId: string, migrationId?: string): Promise<string> => {
  try {
    const deploymentsStore = useDeploymentsStore();
    let deployment = deploymentsStore.getItemById(deploymentId);
    if (!deployment && migrationId) {
      await deploymentsStore.fetchItem(migrationId, deploymentId);
      deployment = deploymentsStore.getItemById(deploymentId);
    }
    return deployment?.name || '';
  } catch (error) {
    console.error(`Failed to fetch deployment with ID ${deploymentId}:`, error);
    return '';
  }
};

export default fetchDeploymentName;
